export default "__VITE_ASSET__Drrzcn9l__"